document.addEventListener('DOMContentLoaded', function() {
    var buch = new Warenkorb('.buch__button--warenkorb');
    buch.initBuch();
});